<template>
  <div class="contact">

    <!-- Header Area Start -->
    <AppHeader></AppHeader>


    <!-- Contents Area Start -->
    <div class="contents">

      <h2>Contact Us</h2>

      <!-- Map -->
      <div class="map">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3173.0932666505983!2d126.83454625125111!3d37.316618379746686!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b6f1ca46eb697%3A0xc54c47fb05dcf07a!2z7JWI7IKw7IucIOykkeyVmeyXreyCrOqxsOumrA!5e0!3m2!1sko!2skr!4v1675056242427!5m2!1sko!2skr" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>

      <!-- Form --> 
      <form action="">
        <div class="input-field">
          <input type="text" name="name" id="input_name" class="autocomplete">
          <label for="input_name">Name</label>
        </div>
        <div class="input-field">
          <input type="email" name="mail" id="input_email" class="autocomplete">
          <label for="input_email">E-Mail</label>
        </div>
        <div class="input-field">
          <textarea cols="40" rows="3" name="message" id="input_msg" class="materialize-textarea"></textarea>
          <label for="input_msg">Textarea</label>
        </div>
        <p><a href="#" id="input_submit" class="waves-effect waves-light btn">SUBMIT NOW</a></p>
      </form>

    </div>


    <!-- Footer Area Start -->
    <AppFooter></AppFooter>

  </div>
</template>

<script>
import AppHeader from './component/Header.vue';
import AppFooter from './component/Footer.vue';

export default {
  name: "Contact",
  components: {
    AppHeader,
    AppFooter
  },
  mounted() {
    this.menuAct5();
  },
  methods: {
    menuAct5(){
      $('.footer a').removeClass('menu-act');
      $('.footer li:nth-child(5) a').addClass('menu-act');
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../sass/partials/_variable.scss';

  .contact{

    // Map
    .map{
      margin-bottom: 70px;

      iframe{
        width: 100%;
        height: 250px;
        border: 1px solid #ccc !important;
      }
    }

    // Form
    form{

      .input-field{
        margin-bottom: 30px;

        label{ font: bold 1.6rem $ff4; top: -15px; }
        textarea{ height: 100px !important; }        
      }

      .btn{
        height: 42px;
        line-height: 42px;
        border-radius: 21px;
        box-shadow: 0 0 0 transparent;
        background-color: $bg-color3;
        color: $color3;
        border: 1px solid #ccc;

        &:hover{ background-color: $bg-color4; }
      }

    }

  }

</style>


// WEBPACK FOOTER //
// src/components/Contact.vue